import React from "react";
import Paper from "@mui/material/Paper";
import ChargingNetworkList from "components/ChargingNetworks/ChargingNetworkList";
import ChargingNetworkModel from "components/ChargingNetworks/Model/ChargingNetworkModel";
import DialogEditChargingNetwork from "components/ChargingNetworks/Model/DialogEditChargingNetwork";
import { Alert, Grid, Snackbar } from "@mui/material";
import EnableDecebleChargingNetwork from "components/ChargingNetworks/EnableDesableChargingNetwork";
import { NetworkTableApi } from "stores/ChargingNetworkStore/NetworkTableApi";
import DialogDeleteChargingNetwork from "components/ChargingNetworks/DialogDeleteChargingNetwork";
function debounce(func, delay) {
  let timer;
  return function (...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, delay);
  };
}
class ChargingNetworkContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      openEdit: false,
      id: null,
      chargingname: "",
      ChargingNetworkConfirmDaialog: false,
      ChargingNetworkStatus: "",
      ChargingNetworkStatusID: "",
      deleteNetworkDaialog:false,
      deleteNetworkId:"",
      inputSearch:'',
      formData: {
        from_date: "",
        to_date: "",
       
      },
      page: 0,
      limit: 100,
      searchKey:'',
      networkdeletSuccess:false
    };

    this.debouncedSearch = debounce(this.performSearch.bind(this), 500);
  }

  componentDidMount() {
    this.props.getNetworkTableAction({
      limit:this.state.limit,
      
    });
  }

  
  onPageChange = (page, rowsPerPage) => {
    this.setState({
      page: page,
      limit: rowsPerPage,
    

    });
    const payload = {
      limit: rowsPerPage,
      page: page,
      search_term:this.state.inputSearch,
      from_date: this.state.formData.from_date,
      to_date: this.state.formData.to_date,
    };
    this.props.getNetworkTableAction(payload);
  };

  handleClickSubmit = async () => {
    const { id, chargingname } = this.state;
    if (chargingname) {
      await NetworkTableApi.UpdateChargingNetworkApi({
        id,
        name: chargingname,
      });
      this.setState({ openEdit: false });

      this.props.getNetworkTableAction();
    }
  };
  searchhandleChange = (name, value) => {
    const query = value;
    this.setState({inputSearch: query });
    this.debouncedSearch(query);
  };
  handleEditUpdateClose = () => {
    this.setState({ openEdit: false });
  };
  performSearch(searchQuery) {
    this.setState({searchKey:searchQuery})
    if (searchQuery) {
      this.props.getNetworkTableAction({
        search_term: searchQuery,
       limit: this.state.limit,
       from_date: this.state.formData.from_date,
       to_date: this.state.formData.to_date,

      });
      return;
    } else this.props.getNetworkTableAction({ limit: this.state.limit ,page:this.state.page,   from_date: this.state.formData.from_date,
      to_date: this.state.formData.to_date,});
  }

  handleDatePickerOpen = () => {
    this.setState({ datePickerOpen: true });
  };

  onDatePickerSub = async () => {
    this.handleFilterApiData();
  };
  handleDatePickerClose = () => {
    this.setState({ datePickerOpen: false });
  };
  handleChange = (name, value) => {
    const { formData } = this.state;
    if (name === "from_date") {
      formData[name] = this.formatDate(new Date(value));
      formData["fromat_date_from"] = this.formatDateMonth(new Date(value));
    } else if (name === "to_date") {
      formData[name] = this.formatDate(new Date(value));
      formData["fromat_date_to"] = this.formatDateMonth(new Date(value));
    } else {
      formData[name] = value;
    }

    this.setState({ formData });
  };
  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  formatDateMonth(date) {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "June",
      "July",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (day.length < 2) day = "0" + day;

    month = month - 1;

    return [day, monthNames[month], year].join(" ");
  }
  handleFilterApiData = async () => {
    await this.props.getNetworkTableAction({
      from_date: this.state.formData.from_date,
      to_date: this.state.formData.to_date,
      search_term:this.state.searchKey,
      page:this.state.page
    });
  };
  handleReset = async () =>{
    await this.props.getNetworkTableAction({
      limit: this.state.limit,
      page: this.state.page,
      search_term:this.state.searchKey
    });
    this.setState({ formData: {
      from_date: "",
      to_date: "",
    }})
  }

  handleOnChange = (e) => {
    this.setState({ chargingname: e.target.value });
  };

  submitCharging = async (id) => {
    var res = await NetworkTableApi.postChargingNetworkApi(id);
    if (res.status === 1) {
      this.handleClickOpen();
    }

    this.props.getNetworkTableAction();
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  handleEditClose = () => {
    this.setState({ openEdit: false, open: false });
  };
  handleEditOpen = (id, chargingname) => {
    this.setState({ openEdit: true, id: `${id}`, chargingname: chargingname });
  };

  handleChargingNetworkModelClose = () => {
    this.setState({ ChargingNetworkConfirmDaialog: false });
  };

  handleStatusChargignNetwork = (id, status) => {
    this.setState({
      ChargingNetworkConfirmDaialog: true,
      ChargingNetworkStatus: status,
      ChargingNetworkStatusID: id,
    });
  };
  handleDeleteChargignNetwork=(id)=>{
    
    this.setState({
      deleteNetworkDaialog:true,
      deleteNetworkId:id
    })
  }
  handleCloseDeleteChargingNetwork=()=>{
    this.setState({
      deleteNetworkDaialog:false,

    })
  }
  handleDeleteNetwork = async () => {
    try {
      const res = await NetworkTableApi.DeleteNetworkApi(this.state.deleteNetworkId);
      if (res && res.status === 1) {
        this.props.getNetworkTableAction({ limit: this.state.limit ,page:this.state.page,   from_date: this.state.formData.from_date,
          to_date: this.state.formData.to_date,});
        this.handleCloseDeleteChargingNetwork();
        this.setState({networkdeletSuccess:true})
      } else {
        console.warn("Delete operation unsuccessful:", res);
      }
    } catch (error) {
      console.error("Error deleting connector:", error);
    }
  };





  handleEnableClickChargingNetwork = async () => {
    const status = this.state.ChargingNetworkStatus;
    const id = this.state.ChargingNetworkStatusID;

    if (status === 1) {
      await NetworkTableApi.AddChargingNetworkEnableDisableApi({
        id,
        status: 0,
      });
      this.setState({ ChargingNetworkStatus: 0 });
      this.props.getNetworkTableAction();
    } else {
      await NetworkTableApi.AddChargingNetworkEnableDisableApi({
        id,
        status: 1,
      });
      this.props.getNetworkTableAction();
    }
    this.setState({ ChargingNetworkConfirmDaialog: false });
  };

  render() {
    const data = this.props?.NetworkTableList?.result;

   

    return (
      <>
        <Grid item xs={12}>
          <Paper sx={{ p: 3, mt: 3.5 }}>
            <ChargingNetworkList
              data={data}
              onClickModel={this.handleClickOpen}
              onClickEdit={this.handleEditOpen}
              handleStatusChargignNetwork={this.handleStatusChargignNetwork}
              submitCharging={(val) => this.submitCharging(val)}
              loading={this.props.loading?.isLoading}
              searchhandleChange={this.searchhandleChange}
              onChange={this.handleChange}
              datePickerOpen={this.state.datePickerOpen}
              handleDatePickerOpen={this.handleDatePickerOpen}
              handleDatePickerClose={this.handleDatePickerClose}
              from_date={this.state.formData.from_date}
              to_date={this.state.formData.to_date}
              onDatePickerSub={this.onDatePickerSub}
              fromat_date_from={this.state.formData.fromat_date_from}
              fromat_date_to={this.state.formData.fromat_date_to}
              onPageChange={this.onPageChange}
              page={this.state.page}
              limit={this.state.limit}
              totalCount={this.props?.NetworkTableList?.result?.totalCount}
              handleReset={this.handleReset}
              handleDeleteChargignNetwork={this.handleDeleteChargignNetwork}

            />
            <DialogDeleteChargingNetwork
            open={this.state.deleteNetworkDaialog}
            handleClose={this.handleCloseDeleteChargingNetwork}
            handleDelete={this.handleDeleteNetwork}
            />

            <ChargingNetworkModel
              handleClose={this.handleClose}
              open={this.state.open}
            />

            <DialogEditChargingNetwork
              handleClose={this.handleEditUpdateClose}
              open={this.state.openEdit}
              data={this.state.chargingname}
              handleOnChange={this.handleOnChange}
              handleClickSubmit={this.handleClickSubmit}
            />

            <EnableDecebleChargingNetwork
              open={this.state.ChargingNetworkConfirmDaialog}
              handleEnable={this.handleEnableClickChargingNetwork}
              handleClose={this.handleChargingNetworkModelClose}
              ChargingNetworkStatus={this.state.ChargingNetworkStatus}
            />
             <Snackbar
              open={this.state.networkdeletSuccess}
              autoHideDuration={3000}
              onClose={() => this.setState({ networkdeletSuccess: false })}
              message="Network delete Successfully"
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <Alert severity="success">Network delete Successfully</Alert>
            </Snackbar>
          </Paper>
        </Grid>
      </>
    );
  }
}

export default ChargingNetworkContainer;
